// extracted by mini-css-extract-plugin
export var expandedRowWrapper = "_1d-6";
export var headerCell = "_1d-2";
export var rowWrapper = "_1d-4";
export var stickyAggregationCell = "_1d-a";
export var stickyAggregationRow = "_1d-7";
export var stickyColumnCell = "_1d-9";
export var stickyColumnHeaderCell = "_1d-8";
export var table = "_1d-1";
export var virtualRowWrapper = "_1d-5";
export var virtualTableContainer = "_1d-0";
export var white = "_1d-3";